const Check = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <circle cx="10.2857" cy="10.2857" r="10.2857" fill="#00BE76" />
      <mask
        id="mask0_1377_5336"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="21"
      >
        <circle cx="10.2857" cy="10.2857" r="10.2857" fill="#03BD7D" />
      </mask>
      <g mask="url(#mask0_1377_5336)">
        <path
          d="M7.5 14.2869L8.75441 12.584L15.5361 6.2002L23.0361 13.7861L15.0484 22.2131L7.5 14.2869Z"
          fill="#009865"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.117 6.37188C14.5107 5.90228 15.2235 5.87332 15.6551 6.3084L16.6199 7.28106C17.0249 7.68941 17.0224 8.34868 16.6141 8.75371L9.99886 15.3152C9.68909 15.6224 9.23528 15.6951 8.85725 15.534C8.73186 15.4832 8.61422 15.4072 8.51253 15.3055L4.49983 11.2928C4.09321 10.886 4.09408 10.2258 4.50081 9.81914L5.34846 8.97148C5.81093 8.50909 6.58027 8.58246 6.9471 9.12383L9.076 12.2664C9.09023 12.2874 9.10724 12.3062 9.12288 12.326C9.13168 12.3163 9.14178 12.3077 9.15022 12.2977L14.117 6.37188Z"
        fill="white"
      />
      <mask
        id="mask1_1377_5336"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="6"
        width="13"
        height="10"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.114 6.37537C14.5077 5.90569 15.2204 5.87581 15.652 6.31092L16.6169 7.28358C17.0219 7.69183 17.0191 8.35114 16.611 8.75623L9.99775 15.3168C9.70558 15.6065 9.2856 15.6858 8.92157 15.559C8.77175 15.5096 8.63056 15.4262 8.51142 15.307L4.49872 11.2943C4.09236 10.8876 4.09306 10.2282 4.4997 9.82166L5.34735 8.97401C5.80987 8.51157 6.5792 8.58484 6.94599 9.12635L9.07489 12.2689C9.08886 12.2895 9.10545 12.3081 9.12079 12.3275C9.12974 12.3177 9.14054 12.3094 9.14911 12.2992L14.114 6.37537Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_1377_5336)">
        <path
          d="M8.78881 16.9699C8.45841 16.54 8.43362 15.9489 8.72686 15.4929L14.8728 5.9354C15.7463 4.57706 17.7536 4.6435 18.5353 6.05662C18.9713 6.84471 18.8656 7.82168 18.2712 8.4983L10.7714 17.0348C10.2376 17.6424 9.2817 17.6111 8.78881 16.9699Z"
          fill="#F1F0EE"
        />
      </g>
    </svg>
  );
};

export default Check;
